import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  View,
} from '@uncinc/react-drupal-core';

import {
  getVocabulary,
} from '../../../../store/actions/UI';
import ViewTypes from '../../../View/Types';

const ArticlesOverview = ({ display }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [filterArray, setFilterArray] = useState([]);
  const [filters, setFilters] = useState({});

  useEffect(() => { dispatch(getVocabulary('themes')); }, [dispatch]);
  const terms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'themes'], List()));

  useEffect(() => {
    if (!filterArray.length) setFilters(['all']);
    else if (filterArray.length === 1) setFilters({ field_themes_target_id: [filterArray[0]] });
    else setFilters({ field_themes_target_id: filterArray });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterArray]);

  return (
    <Container className="ParagraphContentOverview">
      <div className="MultipleFieldsFilter">
        <p onClick={() => setFilterArray([])}>Toon alleen</p>
        <ViewTypes entities={terms} filterArray={filterArray} setFilterArray={setFilterArray} placeholder={t('article.filter_placeholder')} />
      </div>
      <View
        id="content_overview"
        display={display}
        page={currentPage}
        setCurrentPage={setCurrentPage}
        type="articles"
        filters={filters}
      />
    </Container>
  );
};

export default ArticlesOverview;
